module.exports = __webpack_public_path__ + "static/media/infiniti-checkmark.52f1e45e.svg";